import { all, fork } from "redux-saga/effects";

import startup from "./startup";
import notifications from "./notifications";
import database from "./database";
import regions from "./regions";
import products from "./products";
import productVideos from "./productVideos";
import sportTypes from "./sportTypes";
import sportVariants from "./sportVariants";
import conditions from "./conditions";
import wishlist from "./wishlist";
import pushNotifications from "./pushNotifications";
import weatherProviders from "./weatherProviders";
import login from "./login";

/*
 * The entry point for all the sagas used in this application.
 */
export default function* root() {
  yield all([
    fork(startup),
    fork(notifications),
    fork(database),
    fork(regions),
    fork(products),
    fork(productVideos),
    fork(sportTypes),
    fork(sportVariants),
    fork(conditions),
    fork(wishlist),
    fork(pushNotifications),
    fork(weatherProviders),
    fork(login)
  ]);
}
